export const environment = {
  production: true,
  PricetDomainURL: 'https://pricet-mcbu.chevron.com/pricetdomain/api/',
  SecurityDomainURL: 'https://pricet-mcbu.chevron.com/securitydomain/api/',
  EnvironmentTag: 'PRD',
  PacerDomainURL: 'https://pricet-mcbu.chevron.com/PerformanceCostExecution/api/',
  PricetWebURL: 'https://pricet-mcbu.chevron.com/pacer',
  SmartDomainURL: 'https://smart-so-mcbu-api.chevron.com/api/v2/',
  PbsorDomainURL: 'https://pbsor-mcbu-api.chevron.com/api/',
  SmartAppURL: 'https://smart-mcbu.chevron.com/',
};
